export default __webpack_public_path__ + "static/media/camera.7acd0f15.svg";